module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/babel-runtime/core-js/object/assign.js
// module id = RNjU
// module chunks = 15